/**
 * @see https://stackoverflow.com/questions/3040677/locale-codes-for-iphone-lproj-folders
 */

export const languages = {
	Europe: {
		sq: "Albanian", // Albania
		eu: "Basque", // Basques
		be: "Belarusian", // Беларусь
		br: "Breton", // Brittany
		bg: "Bulgarian", // България
		ca: "Catalan", // España
		hr: "Croatian", // Hrvatska
		cs: "Czech", // Česko
		da: "Danish", // Danmark
		nl: "Dutch", // Nederland
		en: "English",
		et: "Estonian", // Eesti
		fo: "Faroese", // Danmark
		fi: "Finnish", // Suomi
		fr: "French", // France, Belgique, Luxembourg, Suisse
		gl: "Galician", // Galicia (España)
		de: "German", // Deutschland, Liechtenstein, Österreich, Schweiz
		el: "Greek", // Ελλάδα
		hu: "Hungarian", // Magyarorszag
		is: "Icelandic", // ísland
		ga: "Irish", // Ireland
		it: "Italian", // Italia
		lv: "Latvian", // Latvija
		lt: "Lithuanian", // Lietuva
		mk: "Macedonian", // North Macedonia
		mt: "Maltese", // Malta
		gv: "Manx", // Ireland / Celtic
		mo: "Moldavian", // Moldova
		se: "Northern Sami", // Norge, Sverige and Suomi
		no: "Norwegian Bokmål", // Norge
		nn: "Norwegian Nynorsk", // Norge
		pl: "Polish", // Polska
		pt: "Portuguese", // Portugal
		ro: "Romanian", // România
		ru: "Russian", // Россия
		gd: "Scottish Gaelic",
		sr: "Serbian", // српски
		sk: "Slovak", // Slovensko
		sl: "Slovenian", // Slovenia
		es: "Spanish", // España
		sv: "Swedish", // Sverige
		tt: "Tatar", // Tatarstan, Россия, Siberian
		tr: "Turkish", // Türkiye
		uk: "Ukrainian", // Ukrayina
		cy: "Welsh", // Wales
		// Montenegrin // Montenegro ???
	},
	"Asia Pacific": {
		my: "Burmese", // Myanmar
		"zh-Hant": "Chinese", // 中国大陆, 澳門, 台灣
		zh: "Chinese / Mandarin", // 中国大陆, 澳門, 台灣
		id: "Indonesian", // Indonesia / bahasa Indonesia
		ja: "Japanese", // 日本
		jv: "Javanese", // Indonesia
		km: "Khmer", // Cambodia
		ko: "Korean", // 대한민국
		lo: "Lao", // Lao
		ms: "Malay", // bahasa Malaysia, Singapore
		mn: "Mongolian", // Mongolia
		su: "Sundanese", // Indonesia
		tl: "Tagalog", // Philippines
		th: "Thai", // ไทย
		to: "Tongan", // Tonga
		ug: "Uyghur", // China
		vi: "Vietnamese", // Vietnam / Cộng hòa Xã hội chủ nghĩa Việt Nam
	},
	"Africa, Middle East and India": {
		af: "Afrikaans", // South Africa
		am: "Amharic", // Amharas (North Ethiopia)
		ar: "Arabic", // Bahrain Arabic (البحرين), مصر (Egypt), الأردن (Jordan), الكويت (Kuwait), اللهجة المغربية (Morocco), عُمان (Oman), قطر (Qatar), المملكة العربية السعودية (Saudi Arabia), Tunisie, الإمارات العربية المتحدة (United Arab Emirates)
		hy: "Armenian", // Armenia (Հայաստան)
		as: "Assamese", // Assam
		az: "Azerbaijani", // Azerbaijan
		bn: "Bengali", // India
		dz: "Dzongkha", // Bhutan
		ka: "Georgian", // Georgia
		gu: "Gujarati", // Gujarat
		he: "Hebrew", // ישראל (Israel)
		hi: "Hindi", // भारत (India)
		kn: "Kannada", // Karnataka
		ks: "Kashmiri", // Jammu and Kashmir (ex India)
		kk: "Kazakh", // Kazakhstan
		rw: "Kinyarwanda", // Rwanda, Eastern Democratic Republic of the Congo, Uganda
		ku: "Kurdish", // Iran, Kurdistan
		ky: "Kyrgyz", // Kyrgyzstan
		mg: "Malagasy", //  Repoblikan'i Madagasikara (Madagascar)
		ml: "Malayalam", // Kerala
		mr: "Marathi", // India
		ne: "Nepali", // Nepal
		or: "Oriya", // Odisha
		om: "Oromo", // Ethiopia
		ps: "Pashto", // Iran
		fa: "Persian", // Iran
		pa: "Punjabi", // Punjab (Culture)
		rn: "Rundi", // Burundi, Democratic Republic of the Congo, Uganda
		// "sg": "Sango", // République Centrafricaine (unsupported?)
		sa: "Sanskrit",
		sd: "Sindhi", // India
		si: "Sinhala", // Sri Lanka
		so: "Somali", // Federal Republic of Somalia
		sw: "Swahili", // Keyna, Uganda
		tg: "Tajik", // Tajikistan
		ta: "Tamil", // Tamil Nadu
		te: "Telugu", // Andhra Pradesh, Telangana, Yanam district of Puducherry
		bo: "Tibetan", // Tibet
		ti: "Tigrinya", // North Ethiopia, Eritrea
		tk: "Turkmen", // Turkmenistan
		ur: "Urdu", // India, Pakistan
		uz: "Uzbek", // Uzbekistan
		yi: "Yiddish", // Israel
	},
	"Latin America and the Caribbean": {
		ay: "Aymara", // Bolivia, Peru and Chile
		gn: "Guarani", // Paraguay, Bolivia, Argentina, Brazil
		la: "Latin", // Spanish
		qu: "Quechua",
	},
	Others: {
		eo: "Esperanto", // All the world
		iu: "Inuktitut", // Canada
		kl: "Kalaallisut", // Greennland
	},
};
